export const TAG_BUTTON_CLICK = 'tag-button-click';

export const tagButtonClick = (tag) => ({
    type: TAG_BUTTON_CLICK,
    payload: tag
});
